import { Pipe, PipeTransform } from '@angular/core';
import { dateToPositionPx } from './date-to-position-px.fn';
import { TimelineTimeframe } from '@wilson/interfaces';

@Pipe({
  name: 'ganttDateToPositionPx',
  standalone: true,
})
export class GanttDateToPositionPxPipe implements PipeTransform {
  transform(
    date: Date | string,
    options: {
      fromRightSide?: boolean;
      timelineWidthPixel: number;
      interval: Interval | TimelineTimeframe;
    },
  ): number {
    if (typeof date === 'string') {
      date = new Date(date);
    }
    return dateToPositionPx(date, options);
  }
}
